/**
 * Converte una stringa data/datetime inviata dal backend (es. "2020-11-06"
 * oppure "2020-11-06T10:30:00") in un oggetto Date mantenendo i componenti
 * esattamente come indicati dal backend, senza conversioni di fuso orario.
 *
 * "2020-11-06" viene interpretata come mezzanotte locale del 6 novembre e NON
 * come mezzanotte UTC: `new Date("2020-11-06")` verrebbe infatti trattata come
 * UTC e, una volta formattata nel fuso del browser, farebbe slittare il giorno
 * nei fusi orari negativi (es. Las Vegas).
 */
export function parseLocalDate(value: string | Date | null | undefined): Date {
  if (!value) {
    return new Date();
  }
  if (value instanceof Date) {
    return new Date(value.getTime());
  }
  const match = value.match(/^(\d{4})-(\d{2})-(\d{2})(?:[T ](\d{2}):(\d{2})(?::(\d{2}))?)?/);
  if (match) {
    const year = Number(match[1]);
    const month = Number(match[2]);
    const day = Number(match[3]);
    const hour = Number(match[4] || 0);
    const minute = Number(match[5] || 0);
    const second = Number(match[6] || 0);
    return new Date(year, month - 1, day, hour, minute, second);
  }
  return new Date(value);
}
